module.exports = __webpack_public_path__ + "media/images/writer/emailer/youtube-icon-51a31c8fda588ddbb6cffeacd2974f3f.png";